require('./bootstrap')
require('./choices');
require('./dual-pricing');

import './repeater/init'

window.AgGrid = require('ag-grid-community')
window.moment = require('moment')
